export default class AccessControlEntryRequest {
  roleCode: string;
  tenantId?: number;
  siteId?: number;
  constructor(roleCode: string, tenantId?: number, siteId?: number) {
    this.roleCode = roleCode;
    this.tenantId = tenantId;
    this.siteId = siteId;
  }
}
